import './index.scss'

const Pulse = ({color}) => {
    return (
        <span className={`pulse ${color}`}/>
    )
}

export default Pulse
